import React from "react";
import {useStyles} from "./styles/SummaryContentsTableStyle";
import {useHistory} from "react-router-dom";
import {
    Typography,
    TablePagination,
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Stepper, Step, StepLabel,
} from "@material-ui/core";
import { ReactComponent as TableSortIcon } from '../../../common/images/TableSortIcon.svg';
import { ReactComponent as TextFieldDownIcon } from '../../../common/images/TextFieldDownIcon.svg';
import {inject, observer} from "mobx-react"
import {EVEN_STEPS, ODD_STEPS} from "../../../common/enums/StepsEnum";
import {DATE_UTIL} from "../../../common/util/date/date.util";
import {injectIntl} from "react-intl";

function SummaryContentsTable(props) {
    const classes = useStyles();
    const history = useHistory();
    const {summaryContentStore, contentStore} = props;
    const {intl} = props;

    const handleChangePage = (event, newPage) => {
        summaryContentStore.setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        summaryContentStore.setRowsPerPage(parseInt(event.target.value, 10));
        summaryContentStore.setPage(0);
    };

    const handleClickStepSort = () => {
        if (summaryContentStore.sortColumn === 'step') {
            summaryContentStore.setIsSortAscending(!summaryContentStore.isSortAscending);
        } else {
            summaryContentStore.setSortColumn('step');
            summaryContentStore.setIsSortAscending(false);
        }
        summaryContentStore.getSummaryContents();
    };

    const handleClickDaySort = () => {
        if (summaryContentStore.sortColumn === 'day') {
            summaryContentStore.setIsSortAscending(!summaryContentStore.isSortAscending);
        } else {
            summaryContentStore.setSortColumn('day');
            summaryContentStore.setIsSortAscending(false);
        }
        summaryContentStore.getSummaryContents();
    };

    const handleClickCreatedDaySort = () => {
        if (summaryContentStore.sortColumn === 'created_datetime') {
            summaryContentStore.setIsSortAscending(!summaryContentStore.isSortAscending);
        } else {
            summaryContentStore.setSortColumn('created_datetime');
            summaryContentStore.setIsSortAscending(false);
        }
        summaryContentStore.getSummaryContents();
    };

    const handleClickUpdatedDaySort = () => {
        if (summaryContentStore.sortColumn === 'updated_datetime') {
            summaryContentStore.setIsSortAscending(!summaryContentStore.isSortAscending);
        } else {
            summaryContentStore.setSortColumn('updated_datetime');
            summaryContentStore.setIsSortAscending(false);
        }
        summaryContentStore.getSummaryContents();
    };

    const editContent = (step,day) => {
        contentStore.setStepValue(step);
        contentStore.setDayValue(day);
        history.push(`/content/step/${step}/day/${day}`);
    }

    const isEvenDay = (day) => {
        return day % 2 === 0;
    }

    const isActiveContent = (step, row) => {
        let isActive = false;
        switch (step) {
            case 1:
                isActive = row.completedFirstContent;
                break;
            case 2:
                isActive = row.completedSecondContent;
                break;
            case 3:
                isActive = row.completedThirdContent;
                break;
            case 4:
                isActive = row.completedFourthContent;
                break;
            case 5:
                isActive = row.completedFifthContent;
                break;
            case 6:
                isActive = row.completedSixthContent;
                break;
            case 7:
                isActive = row.completedSeventhContent;
                break;
            default:
                break;
        }
        return isActive;
    }

    return (
        <Box className={classes.root}>
            <TableContainer className={classes.tableBox}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead className={classes.tableHeadStyle}>
                        <TableRow>
                            <TableCell
                                align='center'
                                style={{minWidth: 55}}
                            >
                                No
                            </TableCell>
                            <TableCell align="left" onClick={handleClickStepSort} style={{minWidth: 55}}>
                                <Box className={classes.sortButton}>
                                    <Typography>Step</Typography>
                                    {summaryContentStore.sortColumn === 'step' &&
                                        (summaryContentStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                    }
                                </Box>
                            </TableCell>
                            <TableCell align="left" onClick={handleClickDaySort} style={{minWidth: 55}}>
                                <Box className={classes.sortButton}>
                                    <Typography>Day</Typography>
                                    {summaryContentStore.sortColumn === 'day' &&
                                        (summaryContentStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                    }
                                </Box>
                            </TableCell>
                            <TableCell align="left">{intl.formatMessage({id: "work_step"})}</TableCell>
                            <TableCell align="left" onClick={handleClickCreatedDaySort} style={{minWidth: 120}}>
                                <Box className={classes.sortButton}>
                                    <Typography>{intl.formatMessage({id: "register_date"})}</Typography>
                                    {summaryContentStore.sortColumn === 'created_datetime' &&
                                        (summaryContentStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                    }
                                </Box>
                            </TableCell>
                            <TableCell align="left" onClick={handleClickUpdatedDaySort} style={{minWidth: 120}}>
                                <Box className={classes.sortButton}>
                                    <Typography>{intl.formatMessage({id: "update_date"})}</Typography>
                                    {summaryContentStore.sortColumn === 'updated_datetime' &&
                                        (summaryContentStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                    }
                                </Box>
                            </TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className={classes.tableBodyStyle}>
                        {summaryContentStore.summaryContentList.map((row,index) => (
                            <TableRow key={index}>
                                <TableCell component="th" scope="row" align='center'>
                                    {
                                        (summaryContentStore.page + 1) * summaryContentStore.rowsPerPage - summaryContentStore.rowsPerPage + 1 + index
                                    }
                                </TableCell>
                                <TableCell align="left">{row.step}</TableCell>
                                <TableCell align="left">{row.day}</TableCell>
                                <TableCell align="left">
                                    {isEvenDay(row.day)
                                        ?
                                        <Stepper alternativeLabel className={classes.activeStepIcon}>
                                            {EVEN_STEPS.map((step) => (
                                                <Step key={step.step} active={isActiveContent(step.step, row)}>
                                                    <StepLabel>{step.text}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    :
                                        <Stepper alternativeLabel className={classes.activeStepIcon}>
                                            {ODD_STEPS.map((step) => (
                                                <Step key={step.step} active={isActiveContent(step.step, row)}>
                                                    <StepLabel>{step.text}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    }
                                </TableCell>
                                <TableCell align="left">{DATE_UTIL.getTimeZoneDate(row.createdDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                <TableCell align="left">{DATE_UTIL.getTimeZoneDate(row.updatedDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                <TableCell align="center">
                                    <Button onClick={()=>editContent(row.step,row.day)} className={classes.tableButton} disableRipple>{intl.formatMessage({id: "modify"})}</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box>
                <TablePagination
                    rowsPerPageOptions={[10, 15, 20]}
                    count={summaryContentStore.summaryContentCount}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage={intl.formatMessage({id: "rows_per_page"})}
                    page={summaryContentStore.page}
                    rowsPerPage={summaryContentStore.rowsPerPage}
                    component="div"
                    labelDisplayedRows={({ count, page }) => {
                        return <span className={classes.displayRow}><span>{page + 1}</span> / {Math.ceil(count / summaryContentStore.rowsPerPage)}</span>
                    }}
                    SelectProps={{
                        IconComponent: TextFieldDownIcon,
                        MenuProps: {
                            className:classes.selectPopover
                        }
                    }}
                    className={classes.paginationBox}
                />
            </Box>
        </Box>
    );
}

export default inject('summaryContentStore', 'contentStore')(injectIntl(observer(SummaryContentsTable)));
